import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import React, { Fragment, useState, useEffect, useCallback, useContext, createContext } from 'react';
import cx from 'classnames';
import useTimeout from '@clearscore-group/lib.hooks.use-timeout';
import Portal from '@clearscore-group/lib.helpers.portal';
import Text from '@clearscore/ui.rainbow.text';
import SuccessSvg from '@clearscore/rainbow.icons.status-success';
import InformationSvg from '@clearscore/rainbow.icons.status-info';
import AttentionSvg from '@clearscore/rainbow.icons.status-warning';
import AlertErrorSvg from '@clearscore/rainbow.icons.status-error';
import CloseSimple from '@clearscore/rainbow.icons.cross';
import ClickableIcon from '@clearscore/ui.rainbow.clickable-icon';
import Button from '@clearscore/ui.rainbow.button';
import toTitleCase from '@clearscore-group/lib.normalize.title-case';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
var styles$1 = {
  "containerWrapper": "containerWrapper--xzsFH",
  "enter": "enter--fK1JC",
  "exit": "exit--XqcWf"
};
var DisplayState = {
  SUCCESS: 'SUCCESS',
  INFO: 'INFO',
  INFO_WARNING: 'INFO_WARNING',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  ALERT_INFO: 'ALERT_INFO'
};
var styles = {
  "component": "component--qgSPT",
  "isDisplayStateSuccess": "isDisplayStateSuccess--FnH98",
  "isDisplayStateWarning": "isDisplayStateWarning--sZM--",
  "isDisplayStateInfo": "isDisplayStateInfo--ziMKa",
  "isDisplayStateInfoWarning": "isDisplayStateInfoWarning--lilOh",
  "isDisplayStateError": "isDisplayStateError--xCFeR",
  "isDisplayStateAlertInfo": "isDisplayStateAlertInfo--MhycN",
  "dismissable": "dismissable--iUHJq",
  "text": "text---QJXh",
  "ctaLink": "ctaLink--k1a5Z",
  "closeIcon": "closeIcon--gc-kG",
  "icon": "icon--DuEPi",
  "atOnly": "atOnly--CXqeK"
};
var NOOP = function NOOP() {
  // noop
};
var getIcon = function getIcon(displayState) {
  var _DisplayState$SUCCESS;
  return (_DisplayState$SUCCESS = {}, _defineProperty(_DisplayState$SUCCESS, DisplayState.SUCCESS, /*#__PURE__*/React.createElement(SuccessSvg, null)), _defineProperty(_DisplayState$SUCCESS, DisplayState.INFO, /*#__PURE__*/React.createElement(InformationSvg, null)), _defineProperty(_DisplayState$SUCCESS, DisplayState.INFO_WARNING, /*#__PURE__*/React.createElement(InformationSvg, null)), _defineProperty(_DisplayState$SUCCESS, DisplayState.WARNING, /*#__PURE__*/React.createElement(AttentionSvg, null)), _defineProperty(_DisplayState$SUCCESS, DisplayState.ERROR, /*#__PURE__*/React.createElement(AlertErrorSvg, null)), _defineProperty(_DisplayState$SUCCESS, DisplayState.ALERT_INFO, /*#__PURE__*/React.createElement(InformationSvg, null)), _DisplayState$SUCCESS)[displayState] || /*#__PURE__*/React.createElement(InformationSvg, null);
};
var Notification = function Notification(_ref) {
  var _ref$dataId = _ref.dataId,
    _dataId = _ref$dataId === void 0 ? '' : _ref$dataId,
    _ref$title = _ref.title,
    _title = _ref$title === void 0 ? '' : _ref$title,
    _ref$displayState = _ref.displayState,
    _displayState = _ref$displayState === void 0 ? DisplayState.INFO : _ref$displayState,
    _ref$ctaText = _ref.ctaText,
    _ctaText = _ref$ctaText === void 0 ? '' : _ref$ctaText,
    _ref$href = _ref.href,
    _href = _ref$href === void 0 ? '' : _ref$href,
    _ref$ctaHandler = _ref.ctaHandler,
    _ctaHandler = _ref$ctaHandler === void 0 ? undefined : _ref$ctaHandler,
    _ref$isNewTab = _ref.isNewTab,
    _isNewTab = _ref$isNewTab === void 0 ? false : _ref$isNewTab,
    _ref$onDismiss = _ref.onDismiss,
    _onDismiss = _ref$onDismiss === void 0 ? NOOP : _ref$onDismiss,
    _ref$isDismissible = _ref.isDismissible,
    _isDismissible = _ref$isDismissible === void 0 ? true : _ref$isDismissible,
    _ref$dismissText = _ref.dismissText,
    _dismissText = _ref$dismissText === void 0 ? 'dismiss notification' : _ref$dismissText,
    children = _ref.children;
  var hasCtaLink = _ctaText && _href;
  var hasCtaButton = _ctaText && !_href;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.component, styles["isDisplayState".concat(toTitleCase(_displayState))], _defineProperty({}, styles.dismissable, _isDismissible)),
    role: "alert",
    "data-qa": "notification",
    "data-id": _dataId
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, getIcon(_displayState)), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, _title ? /*#__PURE__*/React.createElement(Text.H4, null, _title) : null, children), hasCtaLink ? /*#__PURE__*/React.createElement("div", {
    className: styles.ctaLink
  }, /*#__PURE__*/React.createElement(Text, {
    dataId: "cta",
    href: _href,
    weight: Text.weights.BOLD,
    isNewTab: _isNewTab,
    type: Text.types.MINI,
    onClick: _ctaHandler
  }, _ctaText)) : null, hasCtaButton ? /*#__PURE__*/React.createElement(Button, {
    isFlat: true,
    type: Button.types.PRIMARY,
    isNarrow: true,
    onClick: _ctaHandler
  }, _ctaText) : null, _isDismissible ? /*#__PURE__*/React.createElement("div", {
    className: styles.closeIcon,
    "data-qa": "notification-dismiss"
  }, /*#__PURE__*/React.createElement(ClickableIcon, {
    onClick: _onDismiss
  }, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(CloseSimple, {
    height: 24,
    width: 24
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.atOnly
  }, _dismissText)))) : null);
};
Notification.DisplayState = DisplayState;
var NotificationController = function NotificationController(_ref2) {
  var _cx2;
  var _ref2$dataId = _ref2.dataId,
    _dataId = _ref2$dataId === void 0 ? '' : _ref2$dataId,
    _ref2$isOpen = _ref2.isOpen,
    _isOpen = _ref2$isOpen === void 0 ? false : _ref2$isOpen,
    _ref2$children = _ref2.children,
    _children = _ref2$children === void 0 ? null : _ref2$children,
    _ref2$duration = _ref2.duration,
    _duration = _ref2$duration === void 0 ? null : _ref2$duration,
    _ref2$displayState = _ref2.displayState,
    _displayState = _ref2$displayState === void 0 ? Notification.DisplayState.INFO : _ref2$displayState,
    _ref2$ctaText = _ref2.ctaText,
    _ctaText = _ref2$ctaText === void 0 ? '' : _ref2$ctaText,
    _ref2$ctaHandler = _ref2.ctaHandler,
    _ctaHandler = _ref2$ctaHandler === void 0 ? undefined : _ref2$ctaHandler,
    _ref2$title = _ref2.title,
    _title = _ref2$title === void 0 ? '' : _ref2$title,
    _ref2$onDismiss = _ref2.onDismiss,
    _onDismiss = _ref2$onDismiss === void 0 ? undefined : _ref2$onDismiss,
    _ref2$isDismissible = _ref2.isDismissible,
    _isDismissible = _ref2$isDismissible === void 0 ? true : _ref2$isDismissible,
    _ref2$href = _ref2.href,
    _href = _ref2$href === void 0 ? '' : _ref2$href,
    _ref2$isNewTab = _ref2.isNewTab,
    _isNewTab = _ref2$isNewTab === void 0 ? false : _ref2$isNewTab;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    render = _useState2[0],
    setRender = _useState2[1];
  useEffect(function () {
    var timer;
    _isOpen ? setRender(true) : timer = setTimeout(function () {
      return setRender(false);
    }, 100);
    return function () {
      return clearTimeout(timer);
    };
  }, [_isOpen, setRender]);
  useTimeout(_onDismiss, _duration);
  return /*#__PURE__*/React.createElement(Portal, {
    className: styles$1.containerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: cx((_cx2 = {}, _defineProperty(_cx2, styles$1.enter, _isOpen), _defineProperty(_cx2, styles$1.exit, !_isOpen), _cx2)),
    "data-qa": "notification-controller",
    "data-id": _dataId
  }, render && /*#__PURE__*/React.createElement(Notification, {
    dataId: _dataId,
    isOpen: _isOpen,
    displayState: _displayState,
    ctaText: _ctaText,
    ctaHandler: _ctaHandler,
    title: _title,
    onDismiss: _onDismiss,
    isDismissible: _isDismissible,
    href: _href,
    isNewTab: _isNewTab
  }, /*#__PURE__*/React.createElement(Text.Body2, null, _children))));
};
var NotificationContext = /*#__PURE__*/createContext(undefined);
var defaultConfig = {
  content: null,
  displayState: Notification.DisplayState.INFO,
  onClose: function onClose() {
    // noop
  },
  isDismissable: true,
  duration: null
};
var NotificationProvider = function NotificationProvider(_ref3) {
  var children = _ref3.children;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var _useState5 = useState(defaultConfig),
    _useState6 = _slicedToArray(_useState5, 2),
    _useState6$ = _useState6[0],
    onClose = _useState6$.onClose,
    duration = _useState6$.duration,
    isDismissable = _useState6$.isDismissable,
    displayState = _useState6$.displayState,
    content = _useState6$.content,
    cta = _useState6$.cta,
    setConfig = _useState6[1];
  var onDismissHandler = useCallback(function () {
    setIsOpen(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);
  var value = React.useMemo(function () {
    return {
      open: function open(notificationConfig) {
        setConfig(_objectSpread(_objectSpread({}, defaultConfig), notificationConfig));
        setIsOpen(true);
      },
      close: onDismissHandler
    };
  }, [onDismissHandler]);
  return /*#__PURE__*/React.createElement(NotificationContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(Fragment, null, children, /*#__PURE__*/React.createElement(NotificationController, {
    duration: duration,
    dataId: "notification-controller",
    isOpen: isOpen,
    isDismissible: isDismissable,
    onDismiss: onDismissHandler,
    displayState: displayState,
    ctaText: cta === null || cta === void 0 ? void 0 : cta.text,
    ctaHandler: cta === null || cta === void 0 ? void 0 : cta.handler
  }, content)));
};
var useNotificationContext = function useNotificationContext() {
  var context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }
  return context;
};
export default Notification;
export { NotificationController, NotificationProvider, useNotificationContext };